import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { ComentariosSolicitacaoAction } from "./ComentariosSolicitacao.action"
import { ComentariosSolicitacaoActionTypes, ComentariosSolicitacaoState } from "./ComentariosSolicitacao.types"


const estadoInicial: ComentariosSolicitacaoState = {
  novoComentario: {
    emEdicao: false,
    estado: EstadoRequisicao.OCIOSO,
    erros: undefined,
  },

  comentarios: {
    idSolicitacao: 0,
    estado: EstadoRequisicao.OCIOSO,
    erros: undefined,
    elementos: [],

    pagina: {
      atual: 1,
      total: 1
    },
  }
}


export const comentariosSolicitacaoReducer: Reducer<ComentariosSolicitacaoState, ComentariosSolicitacaoActionTypes> = (state = estadoInicial, action): ComentariosSolicitacaoState => {
  
  // Novo comentário
  if (ComentariosSolicitacaoAction.criacao.iniciar.match(action)) {
    return {
      ...state,

      novoComentario: {
        emEdicao: true,
        estado: EstadoRequisicao.OCIOSO,
        erros: undefined
      }
    }
  } else if (ComentariosSolicitacaoAction.criacao.cancelar.match(action)) {
    return {
      ...state,

      novoComentario: {
        ...state.novoComentario,
        emEdicao: false,
      }
    }
  } else if (ComentariosSolicitacaoAction.criacao._persistir.pending.match(action)) {
    return {
      ...state,

      novoComentario: {
        ...state.novoComentario,
        estado: EstadoRequisicao.CARREGANDO,
      }
    }
  } else if (ComentariosSolicitacaoAction.criacao._persistir.fulfilled.match(action)) {
    return {
      ...state,

      novoComentario: {
        ...state.novoComentario,
        estado: EstadoRequisicao.BEM_SUCEDIDO,
        emEdicao: false,
      },

      comentarios: {
        ...state.comentarios,
        elementos: [
          action.payload,
          ...state.comentarios.elementos
        ]
      }
    }
  } else if (ComentariosSolicitacaoAction.criacao._persistir.rejected.match(action)) {
    return {
      ...state,

      novoComentario: {
        ...state.novoComentario,
        estado: EstadoRequisicao.FALHOU,
        erros: action.payload as ResponseError,
      }
    }
  // Comentários
  } else if (ComentariosSolicitacaoAction.lista._carregar.pending.match(action)) {
    const { idSolicitacao, acao } = action.meta.arg;
    
    const elementos = acao === 'carregarPrimeiraPagina'
      ? []
      : state.comentarios.elementos;
    
    let paginaAtual = 0;
    if (acao === 'carregarPaginaSeguinte') {
      paginaAtual = state.comentarios.pagina.atual+1;
    } else if (acao === 'tentarCarregarNovamentePaginaAtual') {
      paginaAtual = state.comentarios.pagina.atual;
    } else {
      paginaAtual = 1;
    }
    
    const totalPaginas = acao === 'carregarPrimeiraPagina'
      ? 1  // Não se sabe quantas páginas são, então considera como sendo somente uma única página
      : state.comentarios.pagina.total;
    
    return {
      ...state,

      comentarios: {
        idSolicitacao: idSolicitacao,
        estado: EstadoRequisicao.OCIOSO,
        erros: undefined,
        elementos: elementos,

        pagina: {
          atual: paginaAtual,
          total: totalPaginas
        },
      }
    }
  } else if (ComentariosSolicitacaoAction.lista._carregar.fulfilled.match(action)) {
    const { idSolicitacao } = action.meta.arg;
    
    return {
      ...state,

      comentarios: {
        idSolicitacao: idSolicitacao,
        estado: EstadoRequisicao.BEM_SUCEDIDO,
        erros: undefined,
        elementos: [
          ...state.comentarios.elementos,
          ...action.payload.content
        ],

        pagina: {
          atual: action.payload.number+1,
          total: action.payload.totalPages
        },
      }
    }
  } else if (ComentariosSolicitacaoAction.lista._carregar.rejected.match(action)) {
    const { idSolicitacao } = action.meta.arg;

    return {
      ...state,

      comentarios: {
        ...state.comentarios,
        idSolicitacao: idSolicitacao,
        estado: EstadoRequisicao.FALHOU,
        erros: action.payload as ResponseError,
      }
    }
  }else if (ComentariosSolicitacaoAction.lista.adicionarNaLista.match(action)) {
    return {
      ...state,

      comentarios: {
        ...state.comentarios,
        elementos: [
          action.payload,
          ...state.comentarios.elementos
        ],
      }
    }
  
  }

  return state;
}
